module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-platforms/master-platforms.component.scss
// module id = ./src/app/master/master-platforms/master-platforms.component.scss
// module chunks = main